import { Link } from "react-router-dom";

interface Neighbor {
  name: string;
  slug: string;
}

interface Props {
  neighborhood: string;
  neighbors: Neighbor[];
}

export default function NearbyAreasBlock({ neighborhood, neighbors }: Props) {
  return (
    <section className="w-full bg-[#fefce8] py-12 md:py-16">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-[#064e3b] text-center mb-8">
          Nearby Service Areas
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {neighbors.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="inline-flex items-center px-5 py-2.5 bg-white text-[#064e3b] text-sm font-medium rounded-full border border-[#064e3b]/20 hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
            >
              Window Repair in {n.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}